import React, { useEffect, useRef } from "react";
import { OperationDetailsPrintData } from "../services/otDetailsServices/OtDetailsServices";
import { GeneratePrint } from "../../common/components/printModal/GeneratePrint";
import { InamdarHospiLogo } from "../../assets/printAssets/InmadarHospiLogo";

export default function OtPharmacyDetailsPrint(props) {
  const printRef = useRef(null);
  const [dataResult, setDataResult] = React.useState(null);

  React.useEffect(() => {
    OperationDetailsPrintData(props?.otDetailsId?.OTHeaderID)
      .then((response) => response.data)
      .then((res) => {
        setDataResult(res.result);
        props.setOpenBackdrop(false);
      })
      .catch((error) => {
        props.setOpenBackdrop(false);
      });
  }, [props?.otDetailsId]);

  useEffect(() => {
    dataResult && printRef && GeneratePrint(printRef);
  }, [dataResult]);

  return (
    <div ref={printRef}>
      <table
        className="w-full"
        style={{
          "-fs-table-paginate": "paginate",
        }}
      >
        <thead>
          <div className=" text-center -mt-11">
            <div className=" flex justify-end">
              <InamdarHospiLogo />
            </div>
            <div className=" -mt-16">
              <h1 className=" font-bold text-[17px]">
CIMET's Inamdar Multispeciality Hospital              </h1>
              <h1 className=" text-[14px] ">
                Sr. No 15, Fatimanagar, Behind Kpct Mall Pune - 411 040.
              </h1>
              <h1 className=" font-semibold text-[17px] border-t-[1px] border-black">
                Operation Details
              </h1>
            </div>
          </div>
          <div>
            <div className=" p-1 border-t-[1px] border-b-[1px] border-black grid grid-cols-[18%_1%_31%_14%_1%_35%]">
              <div className=" font-semibold text-[14px]">Patient Name</div>
              <div className="font-semibold text-[14px]">:</div>
              <div className="text-[14px]">{dataResult?.PatientName}</div>
              <div className=" font-semibold text-[14px]">Age:</div>
              <div className="font-semibold text-[14px]">:</div>
              <div className="text-[14px]">{dataResult?.AgeYear}</div>
              <div className=" font-semibold text-[14px]">Date</div>
              <div className="font-semibold text-[14px]">:</div>
              <div className="text-[14px]">{dataResult?.Date}</div>
              <div className=" font-semibold text-[14px]">Operation No</div>
              <div className="font-semibold text-[14px]">:</div>
              <div className="text-[14px]">{dataResult?.OTSheetNo}</div>
              <div className=" font-semibold text-[14px]">Patient Category</div>
              <div className="font-semibold text-[14px]">:</div>
              <div className="text-[14px]">{dataResult?.PatientCategory}</div>
              <div className=" font-semibold text-[14px]">Bed No</div>
              <div className="font-semibold text-[14px]">:</div>
              <div className="text-[14px]">{dataResult?.BedNo}</div>
              <div className=" text-[14px] font-semibold">Reg. No</div>
              <div className=" text-[14px] font-semibold">:</div>
              <div className=" text-[14px]">{dataResult?.MRNo}</div>
            </div>
          </div>
        </thead>
        <tbody className="w-full">
          <div className="border-dashed  border-b-[1px] border-black grid grid-cols-[14%_1%_35%_14%_1%_35%] p-1">
            <div className=" text-[14px] font-semibold">Theatre Name</div>
            <div className=" text-[14px] font-semibold">:</div>
            <div className=" text-[14px]">{dataResult?.TheatorName}</div>
            <div className=" text-[14px] font-semibold">Start Time</div>
            <div className=" text-[14px] font-semibold">:</div>
            <div className=" text-[14px]">{dataResult?.StartTime}</div>
            <div className=" text-[14px] font-semibold">Anaesthesia</div>
            <div className=" text-[14px] font-semibold">:</div>
            <div className=" text-[14px]">{dataResult?.Anaesthesia}</div>
            <div className=" text-[14px] font-semibold">End Time</div>
            <div className=" text-[14px] font-semibold">:</div>
            <div className=" text-[14px]">{dataResult?.EndTime}</div>
            <div className=" text-[14px] font-semibold">Category</div>
            <div className=" text-[14px] font-semibold">:</div>
            <div className=" text-[14px]">{dataResult?.otCategory}</div>
            <div className=" grid grid-cols-[14%_1%_85%] text-[14px] col-span-6">
              <div className=" font-semibold">Remark</div>
              <div>:</div>
              <div>{dataResult?.Remark}</div>
            </div>
          </div>
          <div>
            <h1 className=" text-[14px] font-semibold">Doctors</h1>

            {/* {dataResult?.docData?.map((data) => {
                
                return <h1>{data?.["DoctorName"]}</h1>;
              })} */}
          </div>
          <div>
            <div className=" grid grid-cols-[14%_1%_85%] text-[14px]">
              <h1>Surgeon</h1>
              <h1>:</h1>
              <h1>
                {dataResult?.docData?.map((data) => {
                  if (data?.["Doctor Type"] !== "Anesthestist") {
                    return <h1>{data?.["Doctor Name"]}</h1>;
                  }
                })}
              </h1>
            </div>
            <div className=" grid grid-cols-[14%_1%_85%] text-[14px]">
              <h1>Anesthestist</h1>
              <h1>:</h1>
              <h1>
                {dataResult?.docData?.map((data) => {
                  if (data?.["Doctor Type"] === "Anesthestist") {
                    return <h1>{data?.["Doctor Name"]}</h1>;
                  }
                })}
              </h1>
            </div>
          </div>
          <div className=" my-2">
            <h1 className="p-1 border-t-[1px] border-b-[1px] border-black text-[14px]">
              Surgery Billing Details
            </h1>
            <table className="w-full border-collapse mt-1">
              <thead className="table-header-group">
                <tr className="border-b-[1px] font-semibold font-Poppins border-black text-start">
                  <th className="text-[12px] w-[45%] text-left">Item Name</th>
                  <th className="text-[12px] w-[15%] text-left">BatchCode</th>
                  <th className="text-[12px] w-[15%] text-left">ExpiryDate</th>
                  <th className="text-[12px] w-[5%] text-right">Qty</th>
                  <th className="text-[12px] w-[10%] text-right">Mrp</th>
                  <th className="text-[12px] w-[10%] text-right">Amount</th>
                </tr>
              </thead>
              <tbody className="table-row-group">
                {dataResult?.otItemList?.map((dataIsDocterList, index) => (
                  <tr key={index}>
                    <td className="text-[12px] w-[45%] text-left">
                      {dataIsDocterList?.Itemname}
                    </td>
                    <td className="text-[12px] w-[15%] text-left">
                      {dataIsDocterList?.BatchCode}
                    </td>
                    <td className="text-[12px] w-[15%] text-left">
                      {dataIsDocterList?.ExpiryDate}
                    </td>
                    <td className="text-[12px] w-[5%] text-right">
                      {dataIsDocterList?.IssueQty.toFixed(2)}
                    </td>
                    <td className="text-[12px] w-[10%] text-right">
                      {dataIsDocterList?.MRP.toFixed(2)}
                    </td>
                    <td className="text-[12px] w-[10%] text-right">
                      {dataIsDocterList?.Amount.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </tbody>
      </table>
    </div>
  );
}
